import React, { useCallback, useState } from "react";
import { connect } from "react-redux";
import {
  jobboardUpgradeShouldTriggerFreeTrialActivation,
  shouldShowJobboardUpgradePrompt,
} from "../../../utils/jobboard/jobboardProfileGate.ts";
import { upgradeJobboardToClientAndActivateTrial } from "../../../store/actions";
import headerNavStyles from "../HeaderNavImproved/HeaderNavImproved.module.scss";
import styles from "./JobboardMobileUpgradeStrip.module.scss";

export type JobboardMobileUpgradeStripVariant = "layoutFlow" | "botoneraInline";

interface JobboardMobileUpgradeStripProps {
  userData: unknown;
  variant: JobboardMobileUpgradeStripVariant;
  upgradeJobboardToClientAndActivateTrial: () => unknown;
}

const JobboardMobileUpgradeStrip: React.FC<JobboardMobileUpgradeStripProps> = ({
  userData,
  variant,
  upgradeJobboardToClientAndActivateTrial,
}) => {
  const u = userData as {
    username?: string;
    rols?: { name?: string }[];
    free_trial?: { status?: string };
  } | null;
  const isGuestAccount = u?.username === "invited@edify.la";
  const showUpgradeHint =
    Boolean(u) && shouldShowJobboardUpgradePrompt(u) && !isGuestAccount;
  const trialActivationCopy =
    showUpgradeHint && jobboardUpgradeShouldTriggerFreeTrialActivation(u);

  const [loading, setLoading] = useState(false);

  const handleUpgrade = useCallback(() => {
    setLoading(true);
    Promise.resolve(upgradeJobboardToClientAndActivateTrial()).finally(() =>
      setLoading(false)
    );
  }, [upgradeJobboardToClientAndActivateTrial]);

  if (!showUpgradeHint) return null;

  const label = loading
    ? "Procesando…"
    : trialActivationCopy
      ? "Cuenta bolsa de trabajo · Activar free trial"
      : "Cuenta bolsa de trabajo · Completar mi cuenta";

  const button = (
    <button
      type="button"
      className={`${headerNavStyles.guestCtaChip} ${headerNavStyles.jobboardTrialCtaChip}`}
      disabled={loading}
      onClick={handleUpgrade}
    >
      {label}
    </button>
  );

  if (variant === "botoneraInline") {
    return <div className={styles.inlineSlot}>{button}</div>;
  }

  return (
    <div className={`${styles.wrap} ${styles.wrapLayoutFlow}`}>
      {button}
    </div>
  );
};

const mapStateToProps = (state: { general: { userData: unknown } }) => ({
  userData: state.general.userData,
});

export default connect(mapStateToProps, { upgradeJobboardToClientAndActivateTrial })(
  JobboardMobileUpgradeStrip
);
